$(function () {
  $(".slider-product-container").slick({
    infinite: true,
    slidesToScroll: 1,
    arrows: false,
    slidesToShow: 6,
    speed: 1000,
    autoplay: true,
    autoplaySpeed: 0,
    pauseOnHover: true,
    cssEase: 'linear',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      }
    ]
  })
})